import { render } from "./RichTextEditable.vue?vue&type=template&id=74020037&scoped=true"
import script from "./RichTextEditable.vue?vue&type=script&lang=js"
export * from "./RichTextEditable.vue?vue&type=script&lang=js"

import "./RichTextEditable.vue?vue&type=style&index=0&id=74020037&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74020037"]])

export default __exports__